import BreadCrumb from "Common/BreadCrumb";
import { BasicButton } from "Common/Components";
import TableContainer from "Common/TableContainer";
import { LucideDot } from "lucide-react";
import { usePClassificationList } from "../../hooks/usePClassificationList";
import DeleteModal from "Common/DeleteModal";
import { ModalForm } from "../../components/ModalForm";

export const PClassificationListview = () => {
  const {
    t,
    columns,
    clasificationsRows,
    showDeleteModal,
    showModalForm,
    onHideModal,
    onDeleteConfirm,
    onHandleCreateClassification,
    onHideModalForm,
  } = usePClassificationList();

  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <DeleteModal
          show={showDeleteModal}
          onHide={onHideModal}
          onDelete={onDeleteConfirm}
        />
        <BreadCrumb
          title={t("productClassification.titleListPage")}
          pageTitle={t("menu.productClassificaction")}
        />
        <div className="card">
          <div className="card-body">
            <div className="flex w-full items-center justify-end flex-wrap">
              <div className="mt-4">
                <BasicButton
                  onClick={onHandleCreateClassification}
                  type="button"
                >
                  <div className="flex flex-row justify-center items-center">
                    <LucideDot size={16} color="#fff" />
                    <span className="ml-2 text-slate-50">
                      {t("productClassification.BtnAddClassification")}
                    </span>
                  </div>
                </BasicButton>
              </div>
            </div>
            <div className="w-full pt-6">
              <TableContainer
                isPagination={true}
                columns={columns}
                data={clasificationsRows}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
                theadclassName="border-b border-slate-200 dark:border-zink-500"
                thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
                tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              ></TableContainer>
            </div>
            <ModalForm showModal={showModalForm} onHide={onHideModalForm} />
          </div>
        </div>
      </div>
    </>
  );
};
